export enum EstadoTareaEnum{
    POR_ENVIAR = 'POR ENVIAR',
    CREADA = 'CREADA',
    ASIGNADA = '5ef0d63e66d65a0209d4441c',
    FINALIZADA = 'FINALIZADA',
    EN_AUTORIZACION = 'EN AUTORIZACIÓN',
    EN_ESPERA = 'EN ESPERA',
    EN_ACTUALIZACION= 'EN ACTUALIZACIÓN',
    EN_CORRECCION= 'EN CORRECCIÓN',
    RECHAZADA = 'RECHAZADA'
}
